/* tslint:disable */
/* eslint-disable */
/**
 * compass-pro
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AlertOptions } from './AlertOptions';
import {
    AlertOptionsFromJSON,
    AlertOptionsFromJSONTyped,
    AlertOptionsToJSON,
    AlertOptionsToJSONTyped,
} from './AlertOptions';

/**
 * 
 * @export
 * @interface EmergencyConfigurationOnAzure
 */
export interface EmergencyConfigurationOnAzure {
    /**
     * 
     * @type {string}
     * @memberof EmergencyConfigurationOnAzure
     */
    org_code: string;
    /**
     * 
     * @type {string}
     * @memberof EmergencyConfigurationOnAzure
     */
    spec_name: string;
    /**
     * 
     * @type {AlertOptions}
     * @memberof EmergencyConfigurationOnAzure
     */
    impact_detection: AlertOptions;
    /**
     * 
     * @type {AlertOptions}
     * @memberof EmergencyConfigurationOnAzure
     */
    fall_detection: AlertOptions;
    /**
     * 
     * @type {AlertOptions}
     * @memberof EmergencyConfigurationOnAzure
     */
    arc_flash_detection: AlertOptions;
    /**
     * 
     * @type {string}
     * @memberof EmergencyConfigurationOnAzure
     */
    object_type: string;
    /**
     * 
     * @type {string}
     * @memberof EmergencyConfigurationOnAzure
     */
    readonly unique_key: string;
    /**
     * 
     * @type {string}
     * @memberof EmergencyConfigurationOnAzure
     */
    id: string;
    /**
     * 
     * @type {boolean}
     * @memberof EmergencyConfigurationOnAzure
     */
    should_force_apply: boolean;
    /**
     * 
     * @type {string}
     * @memberof EmergencyConfigurationOnAzure
     */
    _etag: string;
    /**
     * 
     * @type {number}
     * @memberof EmergencyConfigurationOnAzure
     */
    _ts: number;
    /**
     * 
     * @type {boolean}
     * @memberof EmergencyConfigurationOnAzure
     */
    readonly is_base_config: boolean;
}



/**
 * Check if a given object implements the EmergencyConfigurationOnAzure interface.
 */
export function instanceOfEmergencyConfigurationOnAzure(value: object): value is EmergencyConfigurationOnAzure {
    if (!('org_code' in value) || value['org_code'] === undefined) return false;
    if (!('spec_name' in value) || value['spec_name'] === undefined) return false;
    if (!('impact_detection' in value) || value['impact_detection'] === undefined) return false;
    if (!('fall_detection' in value) || value['fall_detection'] === undefined) return false;
    if (!('arc_flash_detection' in value) || value['arc_flash_detection'] === undefined) return false;
    if (!('object_type' in value) || value['object_type'] === undefined) return false;
    if (!('unique_key' in value) || value['unique_key'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('should_force_apply' in value) || value['should_force_apply'] === undefined) return false;
    if (!('_etag' in value) || value['_etag'] === undefined) return false;
    if (!('_ts' in value) || value['_ts'] === undefined) return false;
    if (!('is_base_config' in value) || value['is_base_config'] === undefined) return false;
    return true;
}

export function EmergencyConfigurationOnAzureFromJSON(json: any): EmergencyConfigurationOnAzure {
    return EmergencyConfigurationOnAzureFromJSONTyped(json, false);
}

export function EmergencyConfigurationOnAzureFromJSONTyped(json: any, ignoreDiscriminator: boolean): EmergencyConfigurationOnAzure {
    if (json == null) {
        return json;
    }
    return {
        
        'org_code': json['org_code'],
        'spec_name': json['spec_name'],
        'impact_detection': AlertOptionsFromJSON(json['impact_detection']),
        'fall_detection': AlertOptionsFromJSON(json['fall_detection']),
        'arc_flash_detection': AlertOptionsFromJSON(json['arc_flash_detection']),
        'object_type': json['object_type'],
        'unique_key': json['unique_key'],
        'id': json['id'],
        'should_force_apply': json['should_force_apply'],
        '_etag': json['_etag'],
        '_ts': json['_ts'],
        'is_base_config': json['is_base_config'],
    };
}

export function EmergencyConfigurationOnAzureToJSON(json: any): EmergencyConfigurationOnAzure {
    return EmergencyConfigurationOnAzureToJSONTyped(json, false);
}

export function EmergencyConfigurationOnAzureToJSONTyped(value?: Omit<EmergencyConfigurationOnAzure, 'unique_key'|'is_base_config'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'org_code': value['org_code'],
        'spec_name': value['spec_name'],
        'impact_detection': AlertOptionsToJSON(value['impact_detection']),
        'fall_detection': AlertOptionsToJSON(value['fall_detection']),
        'arc_flash_detection': AlertOptionsToJSON(value['arc_flash_detection']),
        'object_type': value['object_type'],
        'id': value['id'],
        'should_force_apply': value['should_force_apply'],
        '_etag': value['_etag'],
        '_ts': value['_ts'],
    };
}

